var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, htmlAttributes = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ width: "20px", height: "24px", viewBox: "0 0 20 24", className: className, style: { fill: 'none' } }, htmlAttributes),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-168.000000, -2884.000000)" },
                React.createElement("g", { transform: "translate(0.000000, 552.000000)" },
                    React.createElement("g", { transform: "translate(0.000000, 492.000000)" },
                        React.createElement("g", { transform: "translate(0.000000, 1448.000000)" },
                            React.createElement("g", { transform: "translate(124.000000, 232.000000)" },
                                React.createElement("g", { transform: "translate(0.000000, 160.000000)" },
                                    React.createElement("g", { transform: "translate(44.000000, 0.000000)" },
                                        React.createElement("polyline", { fill: "#6B2879", points: "9.69230382 13 6.12145749 15.9977586 6.12145749 21.0022418 9.69230382 24 13.2631579 21.0022418 13.2631579 15.9977586 9.69230382 13" }),
                                        React.createElement("polyline", { fill: "#008A2B", points: "9.18218623 12.3494948 13.876404 14 18.5178057 11.4093344 19.3846154 6.65282276 14.6903976 5 10.0489959 7.59066563 9.18218623 12.3494948" }),
                                        React.createElement("polyline", { fill: "#89B241", points: "10.2024291 7.34717724 9.33561944 2.59066563 4.69422606 0 0 1.65282276 0.866818019 6.40933437 5.5082114 9 10.2024291 7.34717724" })))))))))));
});
